// import React, { useEffect, useState } from "react";
// import { Tooltip } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import { Link, useNavigate } from "react-router-dom"; // Added Link here
// import PaginationComponent from "../../Components/PaginationComponent";
// import toast from "react-hot-toast";
// import dispenserService from "../../Services/dispenserService";

// const RegisterUsers = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const itemsPerPage = 10;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [patients, setPatients] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const getUsers = async () => {
//       try {
//         setLoading(true);
//         const response = await dispenserService.fetchAll();
//         console.log(response);
//         setPatients(response.dispensers);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error("Error fetching Patients");
//       }
//     };
//     getUsers();
//   }, []);

//   useEffect(() => {
//     const filteredResult =
//       patients?.filter((item) =>
//         item?.name?.toLowerCase().includes(searchData.toLowerCase())
//       ) || [];
//     setFilteredData(filteredResult);
//     setCurrentPage(1);
//   }, [searchData, patients]);

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const options = { year: "numeric", month: "short", day: "numeric" };
//     return new Date(dateString).toLocaleDateString("en-US", options);
//   };

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[19px] text-gray-700 font-[700]">Users</h1>
//         <h1 className="ml-[3%] text-[13px] text-gray-700 mb-4">
//           {filteredData?.length || 0} records found
//         </h1>

//         <div className="flex mt-8 flex-row-reverse justify-between px-[3%]">
//           {/* Dropdown for navigation */}
//           <div className="w-[40%]">
//             <select
//               onChange={(e) => {
//                 const selectedPage = e.target.value;
//                 if (selectedPage) {
//                   navigate(selectedPage);
//                 }
//               }}
//               className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
//             >
//               <option value="" disabled selected>
//                 Select the User to Add
//               </option>
//               <option value="AddEditUser">Admin</option>
//               <option value="AddEditHR">HR</option>
//               <option value="AddEditDispenser">Dispenser</option>
//             </select>
//           </div>

//           <div className="w-[40%]">
//             <input
//               type="search"
//               placeholder="Search Here..."
//               value={searchData}
//               onChange={(e) => setSearchData(e.target.value)}
//               className="block w-[90%] pl-10 text-gray-900 p-2 rounded-md border-gray-800 bg-white focus:outline-none"
//             />
//             <SearchIcon className="mt-[-4rem] text-gray-700 ml-2" />
//           </div>
//         </div>

//         <div className="mx-[3%]">
//           <table className="w-[100%] rounded-xl overflow-hidden">
//             <thead className="bg-gray-700">
//               <tr className="text-white text-xs text-left capitalize leading-normal">
//                 <th className="py-4 w-[10%] pl-4">
//                   User NO.
//                 </th>
//                 <th className="py-4 w-[10%] pl-4">
//                   Name
//                 </th>
//                 <th className="py-4 w-[25%] pl-4">
//                   Email
//                 </th>
//                 <th className="py-4 w-[15%] pl-4">
//                   Phone
//                 </th>
//                 <th className="py-4 w-[15%] pl-4">
//                   Address
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData?.map((patient) => (
//                 <tr
//                   key={patient?.patient_id}
//                   className="bg-white text-xs text-left border-t-[1px] border-gray-200"
//                 >
//                   <td className="py-4 w-[10%] pl-4">
//                     <p className="font-bold">
//                       {patient?.id}.
//                     </p>
//                   </td>
//                   <td className="py-4 w-[10%]">
//                     <p className="font-semibold pl-4">
//                       {patient?.name}
//                     </p>
//                   </td>
//                   <td className="py-4 w-[25%] pl-4">
//                     <p className="font-medium">
//                       {patient?.email}
//                     </p>
//                   </td>
//                   <td className="py-4 w-[15%]">
//                     <p className="font-medium pl-4">
//                       {patient?.phone}
//                     </p>
//                   </td>
//                   <td className="w-[15%]">
//                     <p className="font-medium pl-4">
//                       {patient?.address}
//                     </p>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <PaginationComponent
//           filteredData={filteredData}
//           setPaginatedData={setPaginatedData}
//           itemsPerPage={itemsPerPage}
//           currentPage={currentPage}
//           setCurrentPage={setCurrentPage}
//         />
//       </div>
//     </div>
//   );
// };

// export default RegisterUsers;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import dispenserService from "../../Services/dispenserService";

const RegisterUsers = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const getUsers = async () => {
      try {
        setLoading(true);
        const response = await dispenserService.fetchAll();
        setPatients(response.dispensers);
      } catch (error) {
        toast.error("Error fetching Users");
      } finally {
        setLoading(false);
      }
    };
    getUsers();
  }, []);

  useEffect(() => {
    const filteredResult =
      patients?.filter((item) =>
        item?.name?.toLowerCase().includes(searchData.toLowerCase()),
      ) || [];
    setFilteredData(filteredResult);
  }, [searchData, patients]);

  const colWidths = ["80px", "130px", "200px", "130px", "160px"];
  const ColGroup = () => (
    <colgroup>
      {colWidths.map((w, i) => (
        <col key={i} style={{ width: w, minWidth: w }} />
      ))}
    </colgroup>
  );

  return (
    <div className="p-3 sm:p-4 font-sans">
      {/* ── Header ── */}
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div>
          <p className="text-xs font-medium tracking-widest uppercase text-gray-500">
            Users
          </p>
        </div>
        <select
          onChange={(e) => {
            if (e.target.value) navigate(e.target.value);
          }}
          className="text-xs border border-gray-200 rounded-lg px-2.5 py-1.5 text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-blue-100"
          defaultValue=""
        >
          <option value="" disabled>
            Add User
          </option>
          <option value="AddEditUser">Admin</option>
          <option value="AddEditHR">HR</option>
          <option value="AddEditDispenser">Dispenser</option>
        </select>
      </div>

      {/* ── Search ── */}
      <div className="relative mb-4">
        <svg
          className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
          />
        </svg>
        <input
          type="search"
          placeholder="Search by name..."
          value={searchData}
          onChange={(e) => setSearchData(e.target.value)}
          className="w-full sm:w-72 pl-9 pr-4 py-3 text-xs border border-gray-200 rounded-lg bg-white text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-100"
        />
      </div>

      {/* ══ MOBILE CARDS ══ */}
      <div className="block sm:hidden space-y-2">
        {loading ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            Loading...
          </div>
        ) : filteredData.length === 0 ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            No users found
          </div>
        ) : (
          filteredData.map((user) => (
            <div
              key={user?.id}
              className="border border-gray-200 rounded-xl bg-white px-3 py-3"
            >
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-[11px] font-semibold text-gray-600 uppercase flex-shrink-0">
                    {user?.name?.charAt(0) || "U"}
                  </div>
                  <div>
                    <p className="text-[12px] font-semibold text-gray-800">
                      {user?.name}
                    </p>
                    <p className="text-[10px] text-gray-400">{user?.id}</p>
                  </div>
                </div>
              </div>
              <div className="divide-y divide-gray-100">
                {[
                  { label: "Email", value: user?.email },
                  { label: "Phone", value: user?.phone },
                  { label: "Address", value: user?.address },
                ].map(({ label, value }) =>
                  value ? (
                    <div key={label} className="flex justify-between py-1.5">
                      <span className="text-[11px] text-gray-400 w-16">
                        {label}
                      </span>
                      <span className="text-[11px] text-gray-700 text-right flex-1 ml-2 truncate">
                        {value}
                      </span>
                    </div>
                  ) : null,
                )}
              </div>
            </div>
          ))
        )}
      </div>

      {/* ══ DESKTOP TABLE ══ */}
      <div className="hidden sm:block border rounded-xl overflow-hidden">
        <div className="overflow-y-auto" style={{ maxHeight: "520px" }}>
          <table
            className="w-full text-sm"
            style={{
              tableLayout: "fixed",
              borderCollapse: "separate",
              borderSpacing: 0,
            }}
          >
            <ColGroup />
            <thead>
              <tr>
                {[
                  { label: "User No.", align: "left" },
                  { label: "Name", align: "left" },
                  { label: "Email", align: "left" },
                  { label: "Phone", align: "left" },
                  { label: "Address", align: "left" },
                ].map(({ label, align }, i) => (
                  <th
                    key={label}
                    className={`sticky top-0 z-20 bg-[#215187] text-${align} px-4 py-2.5 text-[11px] text-gray-100 uppercase font-medium ${
                      i < 4 ? "border-r border-white/10" : ""
                    }`}
                  >
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan={5}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    Loading...
                  </td>
                </tr>
              ) : filteredData.length === 0 ? (
                <tr>
                  <td
                    colSpan={5}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    No users found
                  </td>
                </tr>
              ) : (
                filteredData.map((user, index) => (
                  <tr
                    key={user?.id}
                    className={`border-b border-gray-100 hover:bg-green-50 transition-colors ${
                      index % 2 ? "bg-gray-50" : "bg-white"
                    }`}
                  >
                    <td className="px-4 py-2.5 text-[12px] font-semibold text-gray-500 border-r border-gray-100">
                      {user?.id}
                    </td>
                    <td className="px-4 py-2.5 border-r border-gray-100">
                      <div className="flex items-center gap-2">
                        <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center text-[10px] font-semibold text-gray-600 uppercase flex-shrink-0">
                          {user?.name?.charAt(0) || "U"}
                        </div>
                        <span className="text-[12px] font-medium text-gray-800 truncate">
                          {user?.name}
                        </span>
                      </div>
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100 truncate">
                      {user?.email}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      {user?.phone}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 truncate">
                      {user?.address}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            <tfoot>
              <tr>
                <td
                  colSpan={5}
                  className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] font-medium text-gray-100 border-t border-white/10"
                >
                  {filteredData?.length || 0} total records
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RegisterUsers;
